import React from 'react';
import { css } from 'emotion';
import { Link } from 'react-router-dom';

import {
  primary as primaryColor,
  primaryDark,
  bright as brightColor,
} from '../colors';
import { h5 } from '../fontSizes';
import { minWidth, tablet } from '../screenSizes';

export const Button = ({
  primary,
  bright,
  className,
  children,
  href,
  noBorder,
  innerRef,
  ...restProps
}) => {
  const buttonBase = css`
    font-size: ${h5};
    color: ${primary || bright ? brightColor : primaryColor};
    border: ${noBorder
      ? 'none'
      : `2px solid ${bright ? brightColor : primaryColor}`};
    padding: 12px 20px;
    ${primary ? `background: ${primaryColor}` : ''};
    text-transform: uppercase;
    text-decoration: none;
    font-weight: 700;

    &:hover,
    &:hover:focus,
    &:active:hover,
    &:focus:hover,
    &:focus:hover:active {
      color: ${brightColor};
      background: ${primary
          ? primaryDark
          : bright ? 'rgba(0, 0, 0, 0.2)' : primaryColor}
        ${primary ? `border-color: ${primaryDark}` : bright ? '' : primary};
      text-decoration: none;
    }

    &:active,
    &:focus,
    &:active:focus {
      color: ${primary || bright ? brightColor : primaryColor};
      text-decoration: none;
    }

    ${minWidth(tablet)} {
      padding: 16px 30px;
    }

    ${className};
  `;

  const content = (
    <div
      css={`
        height: 100%;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        flex-wrap: wrap;
      `}
    >
      {children}
    </div>
  );

  return href ? (
    <Link innerRef={innerRef} to={href} className={buttonBase} {...restProps}>
      {content}
    </Link>
  ) : (
    <button
      ref={innerRef}
      type="button"
      css={`
        background: none;
        cursor: pointer;

        ${buttonBase};
      `}
      {...restProps}
    >
      {content}
    </button>
  );
};



// WEBPACK FOOTER //
// ./app/components/Button.js